import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScannerScanDetailComponent } from './scanner-scan-detail.component';

const routes: Routes = [{ path: '', component: ScannerScanDetailComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScannerScanDetailRoutingModule {}
